<template>
	<!-- Blog start -->
	<section class="section" id="board">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-lg-7 text-center">
					<h2 class="fw-bold">공지사항</h2>
				</div>
			</div>
			<div class="row">
				<h4 class="mt-5 pt-3">{{ notice.noticeTitle }}</h4>
				<h6 class="mt-2 mb-4 pb-4 border-bottom">{{ notice.noticeDate }}</h6>
				<div v-html="notice.noticeContent"></div>

				<!-- <p class="" v-for="(line, index) in noticeContent" :key="index">
					{{ line }}
				</p> -->
			</div>
			<div class="mt-5">
				<a href="/#board" class="btn btn-outline-secondary btn-sm">메인으로 돌아가기</a>
			</div>
			<!-- end row -->
		</div>
		<!-- end container -->
	</section>
	<!-- Blog end -->
</template>
<script>
import Swal from "../../../js/sweetalert2.min.js";
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.xsrfCookieName = "XSRF-TOKEN";
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";

export default {
	data() {
		return {
			link: "/signin",
			linkText: "로그인",
			notice: [],
			noticeContent: ""
		};
	},
	beforeMount() {
		this.getNotice();
	},
	mounted() {},
	methods: {
		checkSignin: function(e) {
			var loginCookie = this.$cookies.get("MID");
			if (loginCookie != undefined && loginCookie != "0") {
				this.link = "/user/myinfo";
				this.linkText = "내정보";
			} else {
				this.link = "/signin";
				this.linkText = "로그인";
			}
		},
		getNotice() {
			let path = this.$route.path;
			console.log(path);
			axios
				.get("/board" + path)
				.then(response => {
					Swal.close();
					console.log(response.data);
					// response.data.noticeContent = response.data.noticeContent.replace(/\n/g, "<br>");
					response.data.noticeDate = this.dateformatByStr(response.data.noticeDate);
					this.notice = response.data;
					// this.noticeContent = response.data.noticeContent.split("\n");
				})
				.catch(error => {
					this.invalidSession(error);
				});
		},
		viewNotice(noticeNum) {
			location.href = "/notice/" + noticeNum;
		},
		dateformat(current_datetime) {
			var month = current_datetime.getMonth() + 1;
			if (month < 10) {
				month = "0" + month;
			}
			var day = current_datetime.getDate();
			if (day < 10) {
				day = "0" + day;
			}
			let formatted_date = current_datetime.getFullYear() + "년 " + month + "월 " + day + "일";
			return formatted_date;
		},
		dateformatByDate(date) {
			const year = date.getFullYear(); // 연도를 가져옴
			const month = String(date.getMonth() + 1).padStart(2, "0"); // 월을 가져오며, 1월이 0이므로 +1, 두 자리로 맞춤
			const day = String(date.getDate()).padStart(2, "0"); // 일을 가져오며, 두 자리로 맞춤
			const hour = String(date.getHours()).padStart(2, "0"); // 일을 가져오며, 두 자리로 맞춤
			const minute = String(date.getMinutes()).padStart(2, "0"); // 일을 가져오며, 두 자리로 맞춤

			return `${year}. ${month}. ${day}.`;
		},
		dateformatByTimestamp(timestamp) {
			const date = new Date(timestamp * 1000); // timestamp를 Date 객체로 변환
			return this.dateformatByDate(date);
		},
		dateformatByStr(str) {
			const date = new Date(str); // timestamp를 Date 객체로 변환
			return this.dateformatByDate(date);
		},

		toDashboard: function() {
			location.href = "/main/dashboard";
		},
		toAnalytics: function() {
			location.href = "/main/pc4";
			//location.href = "/main/analytics";
		},
		toRank: function() {
			location.href = "/main/rank";
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/main/Notice.vue